import axiosInstance from "~/shared/api/axios-instance";

export const updateCameraAnalysisNumber = async (params: {
  branchUid: string;
  versionId?: number;
  cameraOrientationId: number;
  analysisNumber: string | null;
}) => {
  const { data } = await axiosInstance.patch(
    `branches/${params.branchUid}/pseudo-camera-orientations/${params.cameraOrientationId}/`,
    {
      version: params.versionId,
      analyzed_id: params.analysisNumber,
    },
  );
  return data;
};
